import React, { Component } from 'react';
import PropTypes from 'prop-types'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import Scrollbars from 'react-custom-scrollbars';
import Dashboard from './parentDashboard'
import AccountHistory from '../../SchoolAdmin/PaymentReports/AccountHistory'
import ViewMenu from '../viewMenu'
import ViewStudent from '../OrderMeals/viewStudent'
import ViewOrders from '../OrderMeals/viewOrderV2';
import BreakfastView from '../OrderMeals/breakfastView'
import Header from './parentHeader'
import { convertUTCDateToLocalDate, getOrderMonthYearByStudent } from '../../../server/util'
import { get } from "../../../server/actionsParent";
import { URL_VERSION } from '../../../server/constants'
import Notifications from './notifications';
import Support from './support';
import NotificationSystem from 'react-notification-system';
import CheckOut from '../CheckOut/checkOut';
import { BeatLoader } from 'react-spinners';
import LunchBreakfastProgram from '../SchoolLunchBreakfastProgram/lunchBreakfastProgram'
import MealBenifitsApplications from '../SchoolMealBenifitsApplications/mealBenifitsApplications'
import MealBenifitsApplicationEdit from '../SchoolMealBenifitsApplications/mealBenifitsApplicationEdit'
import MealBenifitsApplicationView from '../SchoolMealBenifitsApplications/mealBenifitsApplicationView'
import { _addNotification, _addNotificationError, setSchoolsModule, setSchoolsPaymentGateways } from '../../../server/util';
import EventPaymentParent from './eventPaymentParent';
import moment from 'moment';
import OrderMenu from '../ManageOrders/orderMenu';
import PaymobCallback from '../../Misc/PaymentModule/paymob/paymobCallback';
import PaymayaCallback from './../../Misc/PaymentModule/paymaya/paymayaCallback'
import Bcac from '../bcac';
import BcacReport from '../bcac/bcacReport/bcacReport';
import PayBCAC from '../bcac/payBCAC';
import BCACHistory from '../bcac/bcacHistory';
import DeviceInfo from './deviceInfo';
import Settings from '../settings';
import ESEAApplication from '../ESEAApplication';
import StudentAccount from './StudentAccount';
var _ = require('lodash');
class parentHome extends Component {
    routeChange = () => {
        this.props.history.push('/parent');
        //  this.context.router.history.push('/parent')
    }

    constructor() {
        super();
        let date = new Date();
        date.setMonth(date.getMonth() + 1)
        this.state = {
            date: date,
            studentsList: [],
            studentData: [],
            schoolObject: {},
            loading: false,
            menuYearMonth: '',
            hdataFilter: { tdate: 'D', sdate: new Date(), edate: new Date() },
            selectedStudentsForPay: {},
            draftData: {}
        }
        this.getMenuOrderYrMonth = this.getMenuOrderYrMonth.bind(this);
        this.getStudentUsersByParent = this.getStudentUsersByParent.bind(this);
    }

    componentWillMount() {
        this.getMenuOrderYrMonth(sessionStorage.getItem('loggedInUserInfo'));
    }
    getMenuOrderYrMonth(parent) {
        // get('/reports/getMenuOrderYrMonth?parentEmail='+parent+'&access_token=').then((response) => {
        let currentYearMonth = new Date().getFullYear() + ("0" + (new Date().getMonth() + 1)).slice(-2)
        get('/reports/monthAndStudentListByEmail?isVersion2=true&parentEmail=' + parent + '&currentYearMonth=' + currentYearMonth + '&access_token=').then((response) => {
            if (!response.statusCode == 200) {
                throw Error(response.statusText);
            }
            console.log('response', response);
            return response.json();
        }).then(data => {
            // let yearMonth=   data.yearMonth|| new Date().getFullYear()+("0" + (new Date().getMonth() + 2)).slice(-2)       
            this.setState({ menuYearMonth: data, loading: false });
            this.getStudentUsersByParent();
        })
            .catch(
                (error) => {
                    this.setState({ loading: false })
                    console.log('getMenuOrderYrMonth', error)
                }
            )
    }
    getStudentUsersByParent() {
        this.setState({ loading: true })
        get('/schoolInfoByParentEmail?isVersion2=true&parentEmail=' + sessionStorage.getItem('loggedInUserInfo') + '&currentDate=' + moment().format('YYYY-MM-DD') + '&access_token=').then(
            (response) => {
                if (!response.ok) {
                    throw Error(response.errorMessage);
                }
                return response.json();
            }).then((schooldata) => {
                let moduleObject = {};
                let paymentGatewayObj = {};
                let foodServiceInfo = {};
                let currency = {};
                let gradesMap = [];
                let countryCode = {};
                let dateFormat = {};
                let nonSchoolDays = {};
                let trxFeeOnSchool = {};
                let appFee = {};
                let stripeAccountIds = {};
                let salesTaxObj = {};
                let schoolTimezone = {};
                let donationObject = {};
                let mealSchoolId = '';
                ((schooldata || {}).schoolDetailsInfos || []).map(element => {
                    currency[element.mealSchoolId] = element.currencySymbol;
                    gradesMap[element.mealSchoolId] = element.gradesMap;
                    countryCode[element.mealSchoolId] = element.countryCode;
                    dateFormat[element.mealSchoolId] = element.dateFormat;
                    nonSchoolDays[element.mealSchoolId] = element.nonSchoolDays;
                    trxFeeOnSchool[element.mealSchoolId] = element.trxFeeOnSchool;
                    schoolTimezone[element.mealSchoolId] = element.schoolTimezone;
                    appFee[element.mealSchoolId] = element.appFee;
                    mealSchoolId = element.mealSchoolId
                    if ((element.stripeAccountId || '').length > 0) {
                        stripeAccountIds[element.mealSchoolId] = element.stripeAccountId;
                    }
                    foodServiceInfo[element.mealSchoolId] = {
                        contactPEmail: element.contactPEmail,
                        contactPName: element.contactPName,
                        contactPPhone: element.contactPPhone,
                    };
                    salesTaxObj[element.mealSchoolId] = {
                        isSalesTax: element.isSalesTax,
                        salesTaxPerc: element.salesTaxPerc
                    }
                    if (element.donationMatchEnabled) {
                        donationObject[element.mealSchoolId] = {
                            donationMealPrice: element.donationMealPrice,
                            donationPartners: (element.donationPartners || []).filter(rec => {
                                return rec.active == true && (rec.balanceLimit || 0) > 0
                            })
                        }
                    }
                });
                sessionStorage.setItem('currency_symbol', JSON.stringify(currency));
                sessionStorage.setItem('mealSchoolId', JSON.stringify(mealSchoolId));
                sessionStorage.setItem('gradesMap', JSON.stringify(gradesMap));
                sessionStorage.setItem('ISD_code', schooldata.schoolDetailsInfos[0].isdCode);
                sessionStorage.setItem('countryCode', JSON.stringify(countryCode));
                sessionStorage.setItem('date_format', JSON.stringify(dateFormat));
                sessionStorage.setItem('nonSchoolDays', JSON.stringify(nonSchoolDays));
                sessionStorage.setItem('trxFeeOnSchool', JSON.stringify(trxFeeOnSchool));
                sessionStorage.setItem('appFee', JSON.stringify(appFee));
                sessionStorage.setItem('stripeAccountIds', JSON.stringify(stripeAccountIds));
                sessionStorage.setItem('foodServiceInfo', JSON.stringify(foodServiceInfo));
                sessionStorage.setItem('salesTax', JSON.stringify(salesTaxObj));
                sessionStorage.setItem('schoolTimeZones', JSON.stringify(schoolTimezone));
                sessionStorage.setItem('donationInfo', JSON.stringify(donationObject));
                let customMsgs = {};
                schooldata.schoolDetailsInfos.map((school) => {
                    let syear = '';
                    let syearSDate = null;
                    let syearEDate = null;
                    let sname = '';
                    let pdfurl = '';
                    let events = [];
                    let pkgRegStudents = [];
                    moduleObject[school.mealSchoolId] = school.moduleAccess || {};
                    paymentGatewayObj[school.mealSchoolId] = school.paymentGateways || []

                    let orderbySchoolYears = _.orderBy(school.schoolYears, ['schoolYear'], ['desc']);
                    let cDate = new Date();
                    for (var i = 0; i < orderbySchoolYears.length; i++) {
                        if (moment(orderbySchoolYears[i].sessionStartDateTime).local() <= cDate && moment(orderbySchoolYears[i].sessionEndDateTime).local() >= cDate) {
                            syear = orderbySchoolYears[i].schoolYear
                            syearSDate = moment(orderbySchoolYears[i].sessionStartDateTime)
                            syearEDate = moment(orderbySchoolYears[i].sessionEndDateTime)
                            sname = orderbySchoolYears[i].name
                            pdfurl = orderbySchoolYears[i].schoolPdfUrl;
                            customMsgs[school.mealSchoolId] = orderbySchoolYears[i].customMessage;
                            events = orderbySchoolYears[i].events

                            pkgRegStudents = orderbySchoolYears[i].pkgRegisteredStds
                            break;
                        }
                        else {
                            if (moment(orderbySchoolYears[i].sessionEndDateTime).local() < cDate) {
                                syear = orderbySchoolYears[i].schoolYear
                                syearSDate = moment(orderbySchoolYears[i].sessionStartDateTime)
                                syearEDate = moment(orderbySchoolYears[i].sessionEndDateTime)
                                sname = orderbySchoolYears[i].name
                                pdfurl = orderbySchoolYears[i].schoolPdfUrl;
                                customMsgs[school.mealSchoolId] = orderbySchoolYears[i].customMessage;
                                events = orderbySchoolYears[i].events
                                pkgRegStudents = orderbySchoolYears[i].pkgRegisteredStds
                                break;
                            }
                        }
                    }
                    this.setState({ loading: false })

                    get('/studentUsers/search/findByEmailAndYearAndSchool?username=' + sessionStorage.getItem('loggedInUserInfo') + '&schoolYear=' + syear + '&mealSchoolId=' + school.mealSchoolId + '&access_token=').then((response) => {
                        if (!response.ok) {
                            //this._addNotificationError();
                            throw Error(response.statusText);
                        }
                        return response.json();
                    }).then((data) => {
                        data._embedded.studentUsers.map((student) => {
                            student.schoolName = school.schoolName;
                            student.mealSchoolId = school.mealSchoolId;
                            student.logoUrl = school.logoLink
                            student.contactPName = school.contactPName
                            student.contactPPhone = school.contactPPhone
                            student.dailySpendingLimit = school.dailySpendingLimit
                            student.contactPEmail = school.contactPEmail
                            student.isPaymentEnabled = school.isPaymentEnabled;
                            student.stripeAccountId = (school.stripeAccountId || '');
                            student.isBreakfastAvailable = school.isBreakfastAvailable
                            student.id = parseInt(student._links.self.href.split('/').pop())
                            student.sessionYear = { schoolYearValue: syear, schoolYear: sname, schoolPdfUrl: pdfurl, sessionStartDate: syearSDate.toDate(), sessionEndDate: syearEDate.toDate() }
                            let schoolObj = this.state.schoolObject;
                            schoolObj[school.mealSchoolId] = {
                                schoolName: school.schoolName,
                                schoolModules: school.moduleAccess,
                                paymentGateways: school.paymentGateways || [],
                                sessionYear: student.sessionYear,
                                events: school.events,
                                pkgRegStudents: school.pkgRegisteredStds,
                                isDonationAccept: school.acceptMealDonation,
                                donationPrice: school.donationMealPrice,
                                setSLimit: school.dailySpendingLimit,
                            };
                            this.setState({
                                schoolObject: schoolObj,
                                studentsList: [...this.state.studentsList, student],
                                loading: false
                            }, () => {
                                let yearmonth = getOrderMonthYearByStudent(this.state.menuYearMonth, parseInt(student._links.self.href.split('/').pop()));
                                if (yearmonth != '')
                                    this.getStudentExtraInfo(student, yearmonth);
                                // this.getMenuOrderYrMonth(sessionStorage.getItem('loggedInUserInfo'),student)                            
                            }
                            )
                            console.log("StudnetList::::::::::", this.state.studentsList);
                        })
                    }).catch((error) => {
                        (error) => {
                            this.setState({ loading: false })
                            console.log('Parent dashboard error', error);
                        }
                    })
                });
                sessionStorage.setItem('customMsgs', JSON.stringify(customMsgs));
                setSchoolsModule(moduleObject);
                setSchoolsPaymentGateways(paymentGatewayObj)
            }).catch(
                (error) => {
                    this.setState({ loading: false })
                    console.log('Parent dashboard error', error);
                    setSchoolsModule({});
                    setSchoolsPaymentGateways({});
                }
            );
    }

    getStudentExtraInfo(student, yearMonth) {
        //alert(JSON.stringify(student, null, 2))
        let stId = student._links.self.href.split('/').pop();
        get(URL_VERSION + '/menuOrderStatus?studentRecId=' + stId + '&yearMonth=' + yearMonth + '&access_token=').then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            console.log('response', response);
            return response.json();
        }).then(data => {
            console.log("Order ", data)
            let orderStatus = ""
            let orderPrice = ''
            let paymentStatus = ''
            let orderDate = ''
            if (data.orderStatus === true) {
                orderStatus = "update"
                orderPrice = data.totalPrice;
                let date = data.orderedDate;
                let t = date.split(/[- : T]/);
                let d = convertUTCDateToLocalDate(new Date(t[0], t[1] - 1, t[2], t[3], t[4], t[5]));
                let actiondate = new Date(d);
                orderDate = (actiondate.getMonth() + 1) + '/' + actiondate.getDate() + '/' + actiondate.getFullYear().toString().substr(-2);
                paymentStatus = data.paymentStatus
            } else if (data.orderStatus === false) {
                orderStatus = "new"
            } else {
                orderStatus = 0;
            }
            let id = stId;
            const { studentsList } = this.state;
            const idx = studentsList.indexOf(student)
            let updatedStudent = { ...student, orderStatus, id, orderPrice, paymentStatus, orderDate };
            const nextEvents = [...studentsList]
            nextEvents.splice(idx, 1, updatedStudent)
            this.setState({
                studentsList: nextEvents, loading: false
            })
        }).catch(
            (error) => {
                this.setState({ loading: false })
                console.log('Get Meal Menu response', error)
            }
        );

    }

    componentDidMount() {
        this._notificationSystem = this.refs.notificationSystem;
    }
    onSelectStudentsForPay = (selectedData) => {
        this.setState({ selectedStudentsForPay: selectedData });
        // window.location.replace('/parent/checkout');
    }

    setDraftData = (newData) => {
        this.setState({ draftData: newData });
    };

    render() {

        return (
            <div>
                <Router>
                    <div id="scrollDiv" style={{ overflowY: 'scroll', overflowX: 'hidden', height: '90vh' }}>
                        <Header />
                        <NotificationSystem ref="notificationSystem" />
                        {/*<Scrollbars style={{minHeight:'510px'}}>*/}
                        <div className='sweet-loading'
                            style={{ position: 'fixed', top: '50%', left: '48%', zIndex: '1000' }}>
                            <BeatLoader
                                size={20}
                                color={'#ea7066'}
                                loading={this.state.loading}
                            />
                        </div>
                        <DeviceInfo />
                        <Switch>
                            <Route path={"/parent/menu/:id(" + (this.state.studentsList.map(student => {
                                return student.id + "|"
                            })).join('') + ")"} render={() => <OrderMenu schoolObject={this.state.schoolObject} selectedStudentsForPay={this.state.selectedStudentsForPay} />} />
                            <Route path={"/parent/orders/:id(" + (this.state.studentsList.map(student => {
                                return student.id + "|"
                            })).join('') + ")"}
                                render={() => <ViewOrders />} />
                            <Route path={"/parent/accountHistory/:id(" + (this.state.studentsList.map(student => {
                                return student.id + "|"
                            })).join('') + ")"} render={() => <StudentAccount student={this.state.studentData} filterData={this.state.hdataFilter} />} />
                            <Route path={"/parent/bcacReport/:id(" + (this.state.studentsList.map(student => {
                                return student.id + "|"
                            })).join('') + ")"}
                                render={() => <BcacReport student={this.state.studentData} filterData={this.state.hdataFilter} />} />
                            <Route path={"/parent/student/:id(" + (this.state.studentsList.map(student => {
                                return student.id + "|"
                            })).join('') + ")"}
                                render={() => <ViewStudent />} />
                            <Route path={"/parent/breakfastview/:sid(" + (this.state.studentsList.map(student => {
                                return student.mealSchoolId + "|"
                            })).join('') + ")"}
                                render={() => <BreakfastView />} />
                            <Route path={"/parent/viewmenu"}
                                render={() => <ViewMenu />} />
                            <Route path="/parent/notifications" component={Notifications} />
                            <Route path="/parent/lunchbreakfastprogram/:sid"
                                render={
                                    (rest) => <LunchBreakfastProgram {...rest} studentList={this.state.studentsList} schoolObject={this.state.schoolObject} draftData={this.state.draftData} />} />
                            <Route path="/parent/mealbenifitsapplications"
                                render={
                                    (rest) => <MealBenifitsApplications {...rest} studentList={this.state.studentsList} schoolObject={this.state.schoolObject} setDraftData={this.setDraftData} />} />

                            <Route path="/parent/mealbenifitsapplication/details"
                                render={
                                    (rest) => <MealBenifitsApplicationView {...rest} studentList={this.state.studentsList} schoolObject={this.state.schoolObject} />} />
                            <Route path="/parent/checkout"
                                render={(rest) =>
                                    <CheckOut {...rest} selectedStudentsForPay={this.state.selectedStudentsForPay} />} />
                            <Route path="/parent/support" render={() => <Support studentData={this.state.studentsList} />} />
                            <Route path="/parent/eventpayment/:schoolId/:schoolYear/" render={() => <EventPaymentParent />} />
                            <Route path="/parent/paymentCallback/" render={(rest) => <PaymobCallback {...rest} />} />
                            <Route path="/parent/paymayaCallback/:status" render={(rest) => <PaymayaCallback {...rest} />} />
                            <Route path="/parent/bcac/" render={(rest) => <Bcac {...rest} />} />
                            <Route path="/parent/bcacEnrollmentHistory/" render={(rest) => <BCACHistory {...rest} />} />
                            <Route path="/parent/pkgDuePayment/" render={rest => <PayBCAC {...rest} />} />
                            <Route path="/parent/settings" render={(rest) => <Settings {...rest} />} />
                            <Route path="/parent/eseaApplication" render={(resp) => <ESEAApplication {...resp} />} />
                            <Route render={(rest) => <Dashboard {...rest} menuYearMonth={this.state.menuYearMonth}
                                studentData={this.state.studentsList}
                                schoolsData={this.state.schoolObject}
                                onSelectStudentsForPay={this.onSelectStudentsForPay} onSelectedSchool={this.onSelectedSchool} />} />

                        </Switch>
                        {/* </Scrollbars>*/}
                    </div>

                </Router>


            </div>
        );
    }
}

parentHome.contextTypes = {
    router: PropTypes.object.isRequired
}

export default parentHome;




// WEBPACK FOOTER //
// ./src/components/Parent/Home/parentHome.js